import { AxiosError } from "axios"

import { UserFacingErrorType } from "./exceptions/userFacingErrorTypes.js"

export const getPredefinedErrorSuffix = (
  error_type: UserFacingErrorType,
  defaultError: string,
): string | null => {
  switch (error_type) {
    case "NOT_FOUND":
      return "Could not find the object, please refresh or contact support"
    // Fall through
  }

  if (defaultError) {
    return defaultError
  }

  switch (error_type) {
    case "MISSING_FIELD":
      return "Field cannot be empty"
    case "NOT_YET_IMPLEMENTED":
      return "Not yet implemented"
    case "BAD_ANSWER_LOCATION":
      return "Can't write an answer in that location"
    case "USER_HAS_NO_DOCUMENTS":
      return "Please upload documents so that we can use them to answer"
    case "NO_QUESTIONS_FOUND":
      return "We couldn't find any questions in the questionnaire. Check that the questions have not already been answered, and that the question location was set correctly"
    case "UNKNOWN_SHEET_LAYOUT":
      return "Could not determine the sheet layout"
    case "USER_DISABLED":
      return "You must upgrade your account."
    case "EXTERNAL_PERMISSION_DENIED":
      return "You do not have the required non-Quilt permissions for this action"
    case "PERMISSION_DENIED":
    case "UNAUTHORIZED":
      return "You do not have the required Quilt permissions for this action"
    case "OUT_OF_DATE":
      return "Answer is out of date, please refresh and retry"
    case "NO_TEXT_FOUND":
      return "We couldn't find any relevant text in the document. If this is a questionnaire, check that the selected Question and Answer columns contain text."
    case "NO_SLACKBOT_CONFIGURATION_FOUND":
      return "The Slack Knowledge Assistant is not enabled for this channel."
    case "ALREADY_EXISTS":
      return "It already exists."
    case "UNSUPPORTED_FILE_TYPE":
      return "That file type is not supported."
    case "CONVERSATION_TOO_LONG":
      return "The conversation is too long, please start another thread by clicking '+ New Thread'"
    default:
      return ""
  }
}

// TODO(mgraczyk): Fix type here.
export const getUserFacingErrorType = (error: unknown): UserFacingErrorType => {
  if (!error) {
    return "UNKNOWN"
  }
  if (error instanceof AxiosError) {
    const maybeData = error.response?.data as
      | {
          error?: string
        }
      | undefined
    if (maybeData) {
      const { error: err } = maybeData
      if (err && err in UserFacingErrorType) {
        return err as UserFacingErrorType
      }
    }
  } else if (typeof error === "string" && error in UserFacingErrorType) {
    return error as UserFacingErrorType
  } else if (typeof error === "object" && "userFacingErrorType" in error) {
    return error.userFacingErrorType as UserFacingErrorType
  } else if (
    typeof error === "object" &&
    "error" in error &&
    (error.error as string) in UserFacingErrorType
  ) {
    return error.error as UserFacingErrorType
  }

  return "UNKNOWN"
}
